export const ParamConstants = {
  memberId: "memberId",
  search: "search=",
  filter: "filters=",
  paramSeparator: "&",
  paramIncluder: "*",
};

export const operatorConstants = {
  equal: "eq",
  lessThan: "lt",
  greaterThan: "gt",
  lessThanEqualTo: "le",
  greaterThanEqualTo: "ge",
  in: "in",
  between: "between",
  contains: "contains",
  startsWith: "startsWith",
  endsWith: "endsWith",
};

export const isEmpty = (value: any) => {
  return value === undefined || value === null;
};
